import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { CartProvider } from "react-use-cart";
import "bootstrap/dist/css/bootstrap.min.css";

import { AppProvider } from "./Context_Ecommerce_Advance/ProductsContext";
import { FilterContextProvider } from "./Context_Ecommerce_Advance/FilterContext";
import { CartContextProvider } from "./Context_Ecommerce_Advance/CartContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppProvider>
    <FilterContextProvider>
      <CartContextProvider>
        <App />
      </CartContextProvider>
    </FilterContextProvider>
  </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
